import * as React from 'react';

import { SvgButton, color } from '@coursera/coursera-ui';
import { SvgChevronDown, SvgChevronUp } from '@coursera/coursera-ui/svg';

import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/program-home';

import 'css!./__styles__/NotificationContainer';

const TrackedSvgButton = withSingleTracked({ type: 'BUTTON' })(SvgButton);

type PropsFromCaller = {
  children: JSX.Element[];
  notificationsToShow: number;
};

const NotificationContainer = ({ children, notificationsToShow }: PropsFromCaller) => {
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);
  const toggleIsExpanded = React.useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    () => setIsExpanded(!isExpanded),
    [isExpanded]
  );

  if (children.length <= 0) {
    return null;
  }

  const hasOverflow = children.length > notificationsToShow;
  const childrenAlwaysVisible = hasOverflow ? children.slice(0, notificationsToShow) : children;
  const childrenConditionallyVisible = hasOverflow ? children.slice(notificationsToShow) : null;
  const disclosureStyle = { display: isExpanded ? undefined : 'none' };
  const ButtonIcon = isExpanded ? SvgChevronUp : SvgChevronDown;
  const buttonText = isExpanded ? _t('Show less notifications') : _t('Show more notifications');
  return (
    <div className="EnterpriseHomeNotifications">
      {childrenAlwaysVisible}
      {hasOverflow && (
        <>
          <div id="EnterpriseHomeNotifications-Disclosure" style={disclosureStyle}>
            {childrenConditionallyVisible}
          </div>
          <TrackedSvgButton
            rootClassName="EnterpriseHomeNotifications-ShowMore"
            trackingName="enterprise_home_notifications_show_more_button"
            svgElement={<ButtonIcon suppressTitle color={color.primary} size={18} />}
            onClick={toggleIsExpanded}
            type="link"
            size="sm"
            htmlAttributes={{
              'aria-controls': 'EnterpriseHomeNotifications-Disclosure',
              'aria-expanded': isExpanded,
            }}
            label={buttonText}
          />
        </>
      )}
    </div>
  );
};

export default NotificationContainer;
